import { IconBlueShowmoreCn, IconBlueShowmoreEn, IconBlueShowmoreJp, IconBlueShowmoreKo } from '@assets/images/icon';

export default {
  back: 'Quay lại blog ORBRO',
  newletter: 'Đăng ký nhận bản tin',
  info: 'Nhận các tin tức đa dạng!',
  placeholder: 'Vui lòng nhập email của bạn',
  subscribe: 'Đăng ký',
  terms1: 'Bằng cách cung cấp thông tin, tôi đồng ý với',
  terms2: '',
  terms3: 'Chính sách xử lý thông tin cá nhân',
  terms4: 'của ORBRO.',

  more: 'Xem thêm',
  less: 'Thu gọn',

  recent: 'Bài viết mới nhất trên blog',
  share: 'Bạn thấy bài viết này hữu ích?<br/> Hãy chia sẻ nhé!',

  priceUnknown: 'Liên hệ riêng',

  price: 'Tổng giá: ',
  product: {
    title: 'Khám phá thành phần sản phẩm',
    access: 'Hãy xem thành phần sản phẩm của hệ thống kiểm soát ra vào đột phá.',
    rtls: 'Hãy xem thành phần sản phẩm của hệ thống định vị tiên tiến.',
    camera: 'Hãy xem thành phần sản phẩm của hệ thống camera.',
    integration: 'Hãy tham khảo các gói sản phẩm có thể ứng dụng trong môi trường y tế.',

    product: 'Hình ảnh sản phẩm',
    spec: 'Thông số kỹ thuật',
    outlook: 'Thiết kế bên ngoài',
    topology: 'Sơ đồ hệ thống',
  },

  uwbVideoDesc: '<br/><strong>(Giải pháp ORBRO ứng dụng công nghệ UWB tại Bệnh viện)</strong>',
  bleVideoDesc: '<br/><strong>(Giải pháp Orbro áp dụng công nghệ BLE trong các cơ sở sản xuất)</strong>',
  svVideoDesc: '<br/><strong>(Giải pháp ORBRO ứng dụng công nghệ camera tại phòng triển lãm)</strong>',
  requestHead: 'Nếu bạn cần thêm thông tin chi tiết',
  request: 'hãy liên hệ với chúng tôi',
  requestTail: ' bất cứ lúc nào.',

  showmoreImg: {
    ko: IconBlueShowmoreKo,
    en: IconBlueShowmoreEn,
    jp: IconBlueShowmoreJp,
    cn: IconBlueShowmoreCn,
  },
};
